import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'emailContainer',
    'smsContainer',
    'letterContainer',
    'postcardContainer',
    'printedContainer',
    'manualContainer',
    'letterCheckbox',
    'postcardCheckbox'
  ];

  declare readonly hasLetterCheckboxTarget: boolean;
  declare readonly letterCheckboxTarget: HTMLInputElement;
  declare readonly hasPostcardCheckboxTarget: boolean;
  declare readonly postcardCheckboxTarget: HTMLInputElement;

  private addressInputComponent: HTMLElement;

  constructor(element: HTMLElement) {
    super(element);

    this.addressInputComponent = document.querySelector('.address-input-component') as HTMLElement;
  }

  public toggleOptions(event: Event): void {
    const noticeIdentifier = (event.target as HTMLElement).getAttribute('data-notice-identifier');

    this.slideContainer(this.container(noticeIdentifier));
    this.toggleIcon(noticeIdentifier);

    if (noticeIdentifier === 'postcard' || noticeIdentifier === 'letter')
      this.openAddressInput();
  }

  private container(identifier): HTMLElement {
    return this.targets.find(`${identifier}Container`) as HTMLElement;
  }

  private slideContainer(container: HTMLElement): void {
    // try to make slideUp and slideDown effects
    if (container.classList.contains('hide')) {
      container.classList.remove('hide');
    } else {
      container.classList.add('hide');
    }
  }

  private toggleIcon(identifier): void {
    const outterContainer = document.querySelector(`#${identifier}_notice_selection`) as HTMLElement;

    if (outterContainer.classList.contains('active_setting')) {
      outterContainer.classList.remove('active_setting');
    } else {
      outterContainer.classList.add('active_setting');
    }
  }

  private openAddressInput(): void {
    // An election can have a letter notice type without a postcard one, or vice versa.
    const postcardChecked = this.hasPostcardCheckboxTarget && this.postcardCheckboxTarget.checked;
    const letterChecked = this.hasLetterCheckboxTarget && this.letterCheckboxTarget.checked;

    if (postcardChecked || letterChecked) {
      this.addressInputComponent?.classList.remove('hide');
    }
  }
}
